export default __webpack_public_path__ + "static/media/logo-ecopro-colored.67e005b8.svg";